import { writable, get } from 'svelte/store';
export const createUserStore = () => {
    const userStore = writable(null);
    const setProfile = (user) => userStore.set(user);
    const reset = () => userStore.set(null);
    const getUserSync = () => get(userStore);
    return {
        subscribe: userStore.subscribe,
        setProfile,
        reset,
        getUserSync,
    };
};
